var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.1,2C3.5,0.7,1.3,1,1.3,2.7c0,1.7,2.3,2.5,2.7,3.5c0.5-1,2.8-1.8,2.8-3.5C6.8,1,4.7,0.7,4.1,2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBg);
export default __webpack_public_path__ + "static/media/heart-bg.0c4217c8959ea49f4b82f2b7f81e7730.svg";
export { ForwardRef as ReactComponent };